// the saved page Alpine object
window.appSaved = () => {
    return {
        activeTab: 'players',
        // activeTab: 'scatterGraphs',
        router: function(state) {
            /*
             * Do nothing is the state is not defined
             */
            if( typeof(state) === 'undefined') {
                return;
            }

            /*
             * if we're at the root then no need to do anything
             */
            if( state.root && state.url =='' ) {
                return;
            }

            /*
             * if the URL is nothing then close popups if one was set
             */
            if( state.url === '' ){
                popupIsActive = false;
                popup.close(true);
                return;
            }

            /*
             * player profile
             */
            let playerProfileUrl = /^player-profile\/([a-z-]+)\/(\d+)$/;
            let playerProfileMatches = state.url.match(playerProfileUrl);
            if( playerProfileMatches && playerProfileMatches.length === 3 ) {
                if( ! state.pushed ) {
                    playerProfile.load({ id: playerProfileMatches[2], name: playerProfileMatches[1] }, true)
                }
                return;
            }

            /*
             * active tab
             */
            let tabUrl = /^(players|comparisons|scatterGraphs)$/;
            let tabMatches = state.url.match(tabUrl);
            if( tabMatches && tabMatches.length === 2 ) {
                this.activeTab = tabMatches[1];
            }
        },

        /*
         * Initialise
         */
        init: function() {
            // basic routing for this page
            Spruce.watch('history', state => this.router(state));
        },

        /*
         * Set the active tab and add a history entry
         */
        setActiveTab(tab) {
            this.activeTab = tab;
            // only push to history if this is different, else replace
            if( tab != this.$store.history.url ) {
                historyManager.push(tab, {});
            } else {
                historyManager.replace(tab);
            }
        }
    }
};
